export default __webpack_public_path__ + "static/media/chatbot1.25b4e565.png";